import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { PublicPage, PublicPageProps } from "../components/template_page/public";
import { useEffect } from 'react';

interface PublicRouteProps extends PublicPageProps { }

const PublicRoute = ({ children, ...restProps }: PublicRouteProps): JSX.Element => {

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });

  }, [location])

  return (
    <PublicPage {...restProps}>
      {children}
    </PublicPage>
  );
}

export default PublicRoute
